export default "__VITE_ASSET__p$wepU7t__"